module.exports = __webpack_public_path__ + "media/images/cellphone_generic_thumb-1da4305e.jpg";